import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { KeyboardDateTimePicker } from '@material-ui/pickers';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import TextField from '../TextField';

const useStyles = makeStyles(
  ({ palette }) => ({
    root: {
      minWidth: 230,
      borderRadius: '2px 2px 0 0',
      '& .MuiButtonBase-root': {
        padding: 0,
      },
    },
    '@global': {
      '.MuiPickersBasePicker-pickerView': {
        minWidth: 248,
        minHeight: 292,
      },
      '.MuiPickersCalendar-transitionContainer': {
        minHeight: 246,
      },
      '.MuiPickersCalendarHeader-dayLabel': {
        color: palette.cncUI.primary.gray['+6'],
        width: 32,
        height: 24,
        margin: '4px 0',
        fontSize: 12,
        lineHeight: '16px',
        textAlign: 'center',
        letterSpacing: '0.32px',
      },
      '.MuiPickersDay-day': {
        color: palette.cncUI.default.primary,
        width: 32,
        height: 32,
        margin: '4px 0',
        borderRadius: 0,
        '&:hover': {
          borderRadius: 0,
        },
        '& .MuiTypography-root': {
          fontSize: 14,
          lineHeight: '18px',
          textAlign: 'center',
          letterSpacing: '0.16px',
        },
      },
      '.MuiPickersDay-current': {
        position: 'relative',
        '&:before': {
          content: "' '",
          display: 'block',
          width: 4,
          height: 4,
          borderRadius: 1,
          background: palette.cncUI.default.primary,
          position: 'absolute',
          bottom: 1,
        },
        '&.MuiPickersDay-hidden:before': {
          background: palette.cncUI.primary.gray['+7'],
        },
      },
      '.MuiPickersDay-daySelected': {
        borderRadius: 0,
        backgroundColor: palette.cncUI.default['+7'],
        '&:hover': {
          backgroundColor: palette.cncUI.default['+7'],
        },
      },
      '.MuiPickersDay-dayRangeStart': {
        background: palette.cncUI.default.primary,
        color: palette.cncUI.default['+10'],
        '&:hover': {
          background: palette.cncUI.default.primary,
          color: palette.cncUI.default['+10'],
        },
        '&:before': {
          background: palette.cncUI.default['+10'],
        },
      },
      '.MuiPickersDay-dayRangeEnd': {
        background: palette.cncUI.default.primary,
        color: palette.cncUI.default['+10'],
        '&:hover': {
          background: palette.cncUI.default.primary,
          color: palette.cncUI.default['+10'],
        },
        '&:before': {
          background: palette.cncUI.default['+10'],
        },
      },
      '.MuiPickersDay-hidden': {
        opacity: 1,
        color: palette.cncUI.primary.gray['+7'],
        background: 'transparent',
      },
    },
    paper: {
      borderRadius: 2,
      boxShadow: palette.cncUI.shadow.container.default,
    },
  }),
  { name: 'CncUI-DateTimePicker' },
);

const DateTimePicker = props => {
  const classes = useStyles();
  const { children, className, ...other } = props;
  const options = {
    className: clsx('cncui-DateTimePicker', classes.root, className),
  };

  return (
    <KeyboardDateTimePicker
      autoOk
      variant="inline"
      format="MM/dd/yyyy hh:mm a"
      placeholder="MM/DD/YYYY hh:mm a"
      ampm
      TextFieldComponent={TextField}
      keyboardIcon={<CalendarIcon />}
      minutesStep={10}
      InputAdornmentProps={{ className: clsx('cncui-DateTimePicker-icon') }}
      PopoverProps={{ PaperProps: { className: classes.paper } }}
      {...options}
      {...other}
    />
  );
};

export default DateTimePicker;
